export default class RequestEpicDescriptor {
  constructor(options) {
    if (!options.apiFunction) {
      throw new Error('Cannot create action descriptor without apiFunction!');
    }
    if (!options.initiatingActionType) {
      throw new Error('Cannot create action descriptor without initiatingActionType!');
    }
    if (!options.requestStatusSelector) {
      throw new Error('Cannot create action descriptor without requestStatusSelector!');
    }
    if (!options.requestStatusTypeFilters) {
      throw new Error('Cannot create action descriptor without requestStatusTypeFilter!');
    }
    if (!options.requestActions) {
      throw new Error('Cannot create action descriptor without requestActions!');
    }
    this.apiFunction = options.apiFunction;
    this.initiatingActionType = options.initiatingActionType;
    this.requestStatusSelector = options.requestStatusSelector;
    this.requestStatusTypeFilters = options.requestStatusTypeFilters;
    this.requestActions = options.requestActions;
    this.alertOnSuccess = options.alertOnSuccess;
    this.alertOnFailure = options.alertOnFailure;
  }
  shouldAlertOnSuccess() {
    return this.alertOnSuccess !== undefined && this.alertOnSuccess;
  }
  shouldAlertOnFailure() {
    return this.alertOnFailure !== undefined && this.alertOnFailure;
  }
  makeAPICall(data = {}) {
    return this.apiFunction(data);
  }
  getInitiatingActionType() {
    return this.initiatingActionType;
  }
  getRequestStatusTypeFilters() {
    return this.requestStatusTypeFilters;
  }
  getRequestStatus(state) {
    return this.requestStatusSelector(state);
  }
  getRequestAction() {
    return this.requestActions.request;
  }
  getSuccessAction() {
    return this.requestActions.success;
  }
  getFailureAction() {
    return this.requestActions.failure;
  }
}